import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

Vue.prototype.$axios = axios
axios.defaults.baseURL = 'https://cfap.ac.cn/api'
//axios.defaults.baseURL = 'http://182.92.243.83:8000'

//  axios.defaults.baseURL = 'http://localhost:8000'

// 请求拦截器：自动添加Token
axios.interceptors.request.use(
  config => {
    // const token = localStorage.getItem('token');
    const token ='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzQ5NzMxOTk3LCJpYXQiOjE3NDkxMjcxOTcsImp0aSI6IjA0N2ViNDY2OTY4NTQ4MGZhNmUxYmY0MzMyZGNmMGE4IiwidXNlcl9pZCI6MX0.MFyq6H2LRJ1iEKSye-8yWDHRGqRFJkuJHohe_LXacaQ'
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理Token失效等错误
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Token失效，跳转登录页（需根据实际路由配置调整）
      //router.push('/login');
    }
    return Promise.reject(error);
  }
);

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
